module.exports = __webpack_public_path__ + "static/portfolio-4-b8f639d8689cc07678e74d55bb6c8be9.jpg";